import Grid2 from '@mui/material/Grid2';
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Box from "@mui/material/Box";
import { useSearchParams } from "react-router-dom";
import { useWorkOrdersContext } from "../context/workOrdersContext";
import { cmmsTheme } from "@setup/theme/cmms-theme";

type Props = {};

export const TypesFilter = ({}: Props) => {
	const { state } = useWorkOrdersContext();
	const [searchParams, setSearchParams] = useSearchParams();

	const type = searchParams.get("type") ?? "";

	const handleFilter = (e: any) => {
		searchParams.set("type", e.target.value);
		setSearchParams(searchParams, { replace: true });
	};

	return (
		<Box>
			<FormControl
				variant="outlined"
				margin="dense"
				fullWidth>
				<InputLabel id="types-select-label">Types</InputLabel>
				<Select
					labelId="types-select-label"
					id="types-select"
					value={type}
					onChange={handleFilter}
					label="Types"
					style={cmmsTheme.styles.filterSelect}>
					{state.typeCodes.map((type) => {
						return (
							<MenuItem key={`logId-${type.id}`} value={type.id}>
								<Grid2 container alignItems="center">
									{type.description}
								</Grid2>
							</MenuItem>
						);
					})}
				</Select>
			</FormControl>
		</Box>
	);
};
